export const tabs: any = {
    "/admin/users": [
        { title: "Users" },
    ],
    "/brand-overview": [
        { title: "Brand Overview" },
    ],
    "/competitors-monitoring": [
        { title: "Competitors Monitoring" },
    ],
    "/competitor-focus": [
        { title: "Competitors Focus" },
    ],
    "/text-ads": [
        { title: "Text Ads" },
    ],
    "/product-listing-ads": [
        { title: "Product Listing Ads" },
    ],
    "/brand-wayback": [
        { title: "Brand Wayback" },
    ],
    "/optimization/campaigns": [
        { title: "Campaigns" },
    ],
    "/optimization/overview": [
        { title: "Performance", label: "Overview", path: "/optimization/overview" },
        { title: "Performance", label: "Funnel", path: "/optimization/funnel" },
        { title: "Performance", label: "Explore", path: "/optimization/traffic-details" },
    ],
    "/optimization/conversions-analysis": [
        { title: "Performance", label: "Overview", path: "/optimization/overview" },
        { title: "Performance", label: "Funnel", path: "/optimization/funnel" },
        { title: "Performance", label: "Explore", path: "/optimization/traffic-details" },
    ],
    "/optimization/funnel": [
        { title: "Performance", label: "Overview", path: "/optimization/overview" },
        { title: "Performance", label: "Funnel", path: "/optimization/funnel" },
        { title: "Performance", label: "Explore", path: "/optimization/traffic-details" },
    ],
    "/optimization/traffic-details": [
        { title: "Performance", label: "Overview", path: "/optimization/overview" },
        { title: "Performance", label: "Funnel", path: "/optimization/funnel" },
        { title: "Performance", label: "Explore", path: "/optimization/traffic-details" },
    ],

    "/optimization/activations/active-mode": [
        { title: "Activations", label: "Active Mode", path: "/optimization/activations/active-mode" },
        { title: "Activations", label: "Scraping", path: "/optimization/scraping" },
        { title: "Activations", label: "KO Bidding", path: "/optimization/activations/ko-bidding", dropdown: true },
        { title: "Activations", label: "KO Bidding Auto", path: "/optimization/activations/ko-bidding-auto" },
    ],
    "/admin/features/live-bidding/ad-group-based": [
        { title: "Activations", label: "Active Mode", path: "/optimization/activations/active-mode" },
        { title: "Activations", label: "Scraping", path: "/optimization/scraping" },
        { title: "Activations", label: "KO Bidding", path: "/optimization/activations/ko-bidding", dropdown: true },
        { title: "Activations", label: "KO Bidding Auto", path: "/optimization/activations/ko-bidding-auto" },
    ],
    "/optimization/activations/ko-bidding": [
        { title: "Activations", label: "Active Mode", path: "/optimization/activations/active-mode" },
        { title: "Activations", label: "Scraping", path: "/optimization/scraping" },
        { title: "Activations", label: "KO Bidding", path: "/optimization/activations/ko-bidding", dropdown: true },
        { title: "Activations", label: "KO Bidding Auto", path: "/optimization/activations/ko-bidding-auto" },
    ],
    "/optimization/activations/ko-bidding-auto": [
        { title: "Activations", label: "Active Mode", path: "/optimization/activations/active-mode" },
        { title: "Activations", label: "Scraping", path: "/optimization/scraping" },
        { title: "Activations", label: "KO Bidding", path: "/optimization/activations/ko-bidding", dropdown: true },
        { title: "Activations", label: "KO Bidding Auto", path: "/optimization/activations/ko-bidding-auto" },
    ],
    "/optimization/scraping": [
        { title: "Activations", label: "Active Mode", path: "/optimization/activations/active-mode" },
        { title: "Activations", label: "Scraping", path: "/optimization/scraping" },
        { title: "Activations", label: "KO Bidding", path: "/optimization/activations/ko-bidding", dropdown: true },
        { title: "Activations", label: "KO Bidding Auto", path: "/optimization/activations/ko-bidding-auto" },
    ],
    "/competitive-intelligence/overview": [
        { title: "Competitive Intelligence", label: "Overview", path: "/competitive-intelligence/overview" },
        { title: "Competitive Intelligence", label: "Search Term Analysis", path: "/competitive-intelligence/st-analysis" },
        { title: "Competitive Intelligence", label: "Competitive Landscape", path: "/competitive-intelligence/competitive-landscape" },
        { title: "Competitive Intelligence", label: "Ads", path: "/competitive-intelligence/ads" },
    ],
    "/competitive-intelligence/competitive-landscape": [
        { title: "Competitive Intelligence", label: "Overview", path: "/competitive-intelligence/overview" },
        { title: "Competitive Intelligence", label: "Search Term Analysis", path: "/competitive-intelligence/st-analysis" },
        { title: "Competitive Intelligence", label: "Competitive Landscape", path: "/competitive-intelligence/competitive-landscape" },
        { title: "Competitive Intelligence", label: "Ads", path: "/competitive-intelligence/ads" },
    ],
    "/competitive-intelligence/st-analysis": [
        { title: "Competitive Intelligence", label: "Overview", path: "/competitive-intelligence/overview" },
        { title: "Competitive Intelligence", label: "Search Term Analysis", path: "/competitive-intelligence/st-analysis" },
        { title: "Competitive Intelligence", label: "Competitive Landscape", path: "/competitive-intelligence/competitive-landscape" },
        { title: "Competitive Intelligence", label: "Ads", path: "/competitive-intelligence/ads" },
    ],
    "/competitive-intelligence/ads": [
        { title: "Competitive Intelligence", label: "Overview", path: "/competitive-intelligence/overview" },
        { title: "Competitive Intelligence", label: "Search Term Analysis", path: "/competitive-intelligence/st-analysis" },
        { title: "Competitive Intelligence", label: "Competitive Landscape", path: "/competitive-intelligence/competitive-landscape" },
        { title: "Competitive Intelligence", label: "Ads", path: "/competitive-intelligence/ads" },
    ],
    "regexp:^/workspaces/(?<id>[0-9]+)": [
        { title: "Administration", label: "Workspace", path: (params: any) => `/workspaces/${params.id}/setup` },
        { title: "Administration", label: "Users", path: (params: any) => `/workspaces/${params.id}/users` },
    ]
};